import { Pipe, PipeTransform } from '@angular/core';
import { WantedItem, WantedStatus } from '../models/wanted-item.model';

@Pipe({
  name: 'wantedItemStatusFilter'
})
export class WantedItemStatusFilterPipe implements PipeTransform {

  transform(wantedItems: WantedItem[], wantedStatus: WantedStatus): any {
    if (!wantedItems || !wantedStatus) {
      return wantedItems;
    }
    return wantedItems.filter(wantedItem => wantedItem.wantedStatus === wantedStatus);
  }

}
